<mat-icon
  svgIcon="solid-lock"
  [class]="iconClass"
  [class.disabled]="!canClick"
  [matTooltip]="'ANGULAR_COMPONENT_LIBRARY.LOCK_ICON.IN_USE' | bmsTranslate"
  matTooltipPosition="above"
  (click)="openUsedByDialog($event)"
></mat-icon>
